<template>
  <div>
    <div class="row">
      <div class="col-md-6 d-flex justify-content-start align-items-center">
        <select
          class="form-select form-select-sm"
          style="width: 90px; margin-right: 20px"
          aria-label=".form-select-sm example"
          @change="filter"
        >
          <option value="100">100</option>
          <option value="300">300</option>
          <option value="500">500</option>
          <option value="1000">1000</option>
        </select>
        <b>Total selected: {{ isPartnerChecked.length }}</b>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-md-12 top-table-buttons">
            <button
              type="button"
              id="skipButton"
              v-if="
                trip_request_id &&
                this.permission.includes('partner-skip') === true
              "
              class="btn btn-primary"
              @click="goTripRequest"
            >
              Skip
            </button>
            <button
              type="button"
              v-if="
                trip_request_id &&
                this.permission.includes('partner-invite') === true
              "
              @click="checkInviteId"
              class="btn btn-primary"
            >
              Invite
            </button>
            <button
              type="button"
              v-if="searchDriverFromPartnerPage && selected.length > 0"
              class="btn btn-primary"
              data-bs-toggle="modal"
              data-bs-target="#invitePartnerModal"
            >
              Invite to Backup TR
            </button>
          </div>
        </div>
      </div>
    </div>
    <div v-if="partners.length > 0">
      <div class="table-responsive mt-2">
        <table class="table table-bordered table-hover" id="partner-table">
          <thead>
            <tr>
              <th></th>
              <th>
                <input
                  type="checkbox"
                  id="selectAllCheckbox"
                  :checked="selectAll"
                  @click="selectCheckbox"
                />
              </th>
              <th>ID</th>
              <th>Name</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Partner Type</th>
              <th>Dropoff Location</th>
              <th>Garage Location</th>
              <th>Vehicle Type</th>
              <th>Tags</th>
              <!-- <th>Vehicle Owner</th> -->
              <th>Role</th>
              <th>Driven By</th>
              <th>Registered By</th>
              <th>Status</th>
              <th>Created At</th>
            </tr>
          </thead>
          <tbody id="tableBody">
            <template v-for="partner in partners" :key="partner.user_id">
              <tr @click="checkVisibility(partner.user_id)">
                <td>
                  <p v-if="!opened.includes(partner.user_id)">
                    <i class="bi bi-chevron-right"></i>
                  </p>
                  <p v-else>
                    <i class="bi bi-chevron-down"></i>
                  </p>
                </td>
                <td>
                  <label class="form-checkbox">
                    <input
                      type="checkbox"
                      @click="
                        checkWhichOneCheckout(
                          partner.user_id,
                          drivers.find(
                            (driver) => driver.user_code === partner.user_id
                          )?.mobile || 0
                        )
                      "
                      :checked="isPartnerChecked.includes(partner.user_id)"
                    />
                    <i class="form-icon"></i>
                  </label>
                </td>
                <td>{{ partner.user_id }}</td>
                <td>
                  <router-link
                    :to="`/trip-request/partners/profile/${partner.user_id}`"
                  >
                    {{
                      drivers.find(
                        (driver) => driver.user_code === partner.user_id
                      )?.name || 'No Name Found'
                    }}
                  </router-link>
                </td>
                <td>
                  <!--                    {{ partner.email }}-->
                  {{
                    drivers.find(
                      (driver) => driver.user_code === partner.user_id
                    )?.email || 'No Email Found'
                  }}
                </td>
                <td>
                  {{
                    drivers.find(
                      (driver) => driver.user_code === partner.user_id
                    )?.mobile || 'No Number Found'
                  }}
                </td>
                <td>{{ partner.partner_type }}</td>
                <td>
                  {{ partner.drop_location ? partner.drop_location : 'N/A' }}
                </td>
                <td>
                  {{
                    partner.garage_location ? partner.garage_location : 'N/A'
                  }}
                </td>
                <td>
                  {{ partner.car_type ? partner.car_type : 'N/A' }}
                </td>
                <td>
                  <span class="badge bg-primary" v-if="partner.tags">{{
                    partner.tags
                  }}</span>
                  <span v-else>N/A</span>
                </td>
                <!-- <td>
                  {{ partner.is_owner ? partner.is_owner : 'N/A' }}
                </td> -->
                <td>
                  {{ roleFromUserService(partner.user_id) }}
                </td>
                <td>
                  {{ partner.is_driven_by ? partner.is_driven_by : 'N/A' }}
                </td>
                <td>
                  {{ partner.registered_by ? partner.registered_by : 'N/A' }}
                </td>
                <td>
                  {{
                    drivers.find(
                      (driver) => driver.user_code === partner.user_id
                    )?.status || 'No status Found'
                  }}
                </td>
                <td>
                  {{
                    partner.created_at
                      ? formatDateUsingMoment(partner.created_at)
                      : 'N/A'
                  }}
                </td>
              </tr>
              <tr v-if="opened.includes(partner.user_id)">
                <td colspan="20">
                  <div class="row">
                    <div class="col-12">
                      <template
                        v-if="
                          roleFromUserService(partner.user_id) == 'Owner' &&
                          partner.owner_fleet_cars
                        "
                      >
                        <template
                          v-for="(carInfo, index) in partner.owner_fleet_cars"
                          :key="index"
                        >
                          <button
                            @click="selectCar(carInfo)"
                            style="margin: 5px"
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#partnerCarEditModal"
                            class="btn btn-sm btn-primary justify-content-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              fill="currentColor"
                              class="bi bi-car-front"
                              viewBox="0 0 16 16"
                              style="margin-right: 2px"
                            >
                              <path
                                d="M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276Z"
                              />
                              <path
                                d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.807.807 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155 1.806 0 4.037-.084 5.592-.155A1.479 1.479 0 0 0 15 9.611v-.413c0-.099-.01-.197-.03-.294l-.335-1.68a.807.807 0 0 0-.43-.563 1.807 1.807 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3H4.82Z"
                              />
                            </svg>
                            {{
                              carInfo.license_plate_number
                                ? carInfo.license_plate_number.toUpperCase()
                                : 'Edit Car Info'
                            }}
                            <span v-if="carInfo.driver_code">
                              |
                              {{
                                drivers.find(
                                  (driver) =>
                                    driver.user_code === carInfo.driver_code
                                )?.name || 'N/A'
                              }}
                            </span>
                            <span v-if="partner.user_id == carInfo.driver_code"
                              >(Owner)</span
                            >
                          </button>
                        </template>
                      </template>
                      <template
                        v-else-if="
                          roleFromUserService(partner.user_id) == 'Driver' &&
                          partner.driver_car
                        "
                      >
                        <template
                          v-for="(carInfo, index) in partner.driver_car"
                          :key="index"
                        >
                          <button
                            @click="selectCar(carInfo)"
                            style="margin: 5px"
                            type="button"
                            data-bs-toggle="modal"
                            data-bs-target="#partnerCarEditModal"
                            class="btn btn-sm btn-primary justify-content-center"
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              fill="currentColor"
                              class="bi bi-car-front"
                              viewBox="0 0 16 16"
                              style="margin-right: 2px"
                            >
                              <path
                                d="M4 9a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm10 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0ZM6 8a1 1 0 0 0 0 2h4a1 1 0 1 0 0-2H6ZM4.862 4.276 3.906 6.19a.51.51 0 0 0 .497.731c.91-.073 2.35-.17 3.597-.17 1.247 0 2.688.097 3.597.17a.51.51 0 0 0 .497-.731l-.956-1.913A.5.5 0 0 0 10.691 4H5.309a.5.5 0 0 0-.447.276Z"
                              />
                              <path
                                d="M2.52 3.515A2.5 2.5 0 0 1 4.82 2h6.362c1 0 1.904.596 2.298 1.515l.792 1.848c.075.175.21.319.38.404.5.25.855.715.965 1.262l.335 1.679c.033.161.049.325.049.49v.413c0 .814-.39 1.543-1 1.997V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.338c-1.292.048-2.745.088-4 .088s-2.708-.04-4-.088V13.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-1.892c-.61-.454-1-1.183-1-1.997v-.413a2.5 2.5 0 0 1 .049-.49l.335-1.68c.11-.546.465-1.012.964-1.261a.807.807 0 0 0 .381-.404l.792-1.848ZM4.82 3a1.5 1.5 0 0 0-1.379.91l-.792 1.847a1.8 1.8 0 0 1-.853.904.807.807 0 0 0-.43.564L1.03 8.904a1.5 1.5 0 0 0-.03.294v.413c0 .796.62 1.448 1.408 1.484 1.555.07 3.786.155 5.592.155 1.806 0 4.037-.084 5.592-.155A1.479 1.479 0 0 0 15 9.611v-.413c0-.099-.01-.197-.03-.294l-.335-1.68a.807.807 0 0 0-.43-.563 1.807 1.807 0 0 1-.853-.904l-.792-1.848A1.5 1.5 0 0 0 11.18 3H4.82Z"
                              />
                            </svg>
                            {{
                              carInfo.license_plate_number
                                ? carInfo.license_plate_number.toUpperCase()
                                : 'Edit Car Info'
                            }}
                            <span v-if="carInfo.driver_code">
                              |
                              {{
                                drivers.find(
                                  (driver) =>
                                    driver.user_code === carInfo.driver_code
                                )?.name || 'N/A'
                              }}
                            </span>
                          </button>
                        </template>
                      </template>
                      <div class="edit-partner-buttons">
                        <button
                          @click="selectPartnerInfo(partner)"
                          style="margin: 5px"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#partnerEditModal"
                          class="btn btn-sm btn-outline-primary justify-content-center"
                        >
                          <i
                            class="bi bi-pencil-square"
                            style="margin-right: 2px"
                          ></i>
                          Edit Profile
                        </button>
                        <button
                          v-if="
                            roleFromUserService(partner.user_id) !== 'Owner'
                          "
                          @click="makeOwner(partner)"
                          style="margin: 5px"
                          type="button"
                          class="btn btn-sm btn-outline-primary justify-content-center"
                        >
                          Make Owner
                        </button>
                        <button
                          v-if="
                            roleFromUserService(partner.user_id) === 'Owner'
                          "
                          @click="selectPartnerInfo(partner)"
                          style="margin: 5px"
                          type="button"
                          data-bs-toggle="modal"
                          data-bs-target="#carAddModal"
                          class="btn btn-sm btn-outline-primary justify-content-center"
                        >
                          <i class="bi bi-plus" style="margin-right: 2px"></i>
                          Add Car
                        </button>
                      </div>

                      <!-- <button
                        @click="selectPartnerInfo(partner)"
                        style="margin: 5px"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#partnerLicenseTypeModal"
                        class="btn btn-sm btn-primary justify-content-center"
                      >
                        <i class="fas fa-edit"></i> License Type
                      </button>
                      <button
                        @click="selectPartnerInfo(partner)"
                        style="margin: 5px"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#partnerStatusChangeModal"
                        class="btn btn-sm btn-primary justify-content-center"
                      >
                        <i class="fas fa-eye"></i> Change Status
                      </button> -->
                    </div>
                  </div>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <!-- Partner Info License Type Modal -->
  <div
    class="modal fade"
    id="partnerLicenseTypeModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="partnerLicenseTypeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <PartnerLicenseType
        :partner="selectedPartner"
        :driver="selectedDriver"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
      ></PartnerLicenseType>
    </div>
  </div>
  <!-- Partner Info Status Change Modal -->
  <div
    class="modal fade"
    id="partnerStatusChangeModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="partnerStatusChangeModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <PartnerStatusChange
        :driver="selectedDriver"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
      ></PartnerStatusChange>
    </div>
  </div>
  <!-- Partner Car Info Edit Modal -->
  <div
    class="modal fade"
    id="partnerCarEditModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="partnerCarEditModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <PartnerCarEdit
        :baseUrl="baseUrl"
        :partner="selectedPartner"
        :driver="selectedDriver"
        :car="selectedCar"
        :cityList="cityList"
        :areaList="areaList"
        :carTypeList="carTypeList"
        :carBrandList="carBrandList"
        :carModelList="carModelList"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
        @openReplaceDriverModal="openReplaceDriverModal"
      ></PartnerCarEdit>
    </div>
  </div>
  <!-- Partner Info Edit Modal -->
  <div
    class="modal fade"
    id="partnerEditModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="partnerEditModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <PartnerEdit
        :baseUrl="baseUrl"
        :partner="selectedPartner"
        :driver="selectedDriver"
        :cityList="cityList"
        :areaList="areaList"
        :carTypeList="carTypeList"
        :carBrandList="carBrandList"
        :carModelList="carModelList"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
      ></PartnerEdit>
    </div>
  </div>
  <!-- Car Add Modal -->
  <div
    class="modal fade"
    id="carAddModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="carAddModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-xl">
      <addCar
        :baseUrl="baseUrl"
        :partner="selectedPartner"
        :carTypeList="carTypeList"
        :carBrandList="carBrandList"
        :carModelList="carModelList"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
      ></addCar>
    </div>
  </div>
  <!-- Replace Driver Modal -->
  <div
    class="modal fade"
    id="replaceDriverModal"
    tabindex="-1"
    data-bs-backdrop="static"
    data-bs-keyboard="false"
    aria-labelledby="replaceDriverModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog">
      <ReplaceDriver
        :baseUrl="baseUrl"
        :carInfo="carInfo"
        @refreshPaginationData="this.$emit('refreshPaginationData')"
      ></ReplaceDriver>
    </div>
  </div>
  <button
    type="button"
    ref="replaceDriverOpenBtn"
    style="display: none"
    data-bs-toggle="modal"
    data-bs-target="#replaceDriverModal"
  ></button>

  <!-- Invited partners to backup TR modal -->
  <teleport to="body">
    <!-- Modal -->
    <div
      class="modal fade"
      id="invitePartnerModal"
      tabindex="-1"
      aria-labelledby="invitePartnerModalLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog modal-lg">
        <InvitePartnersToBackupTRVue
          :selectedDriverDetails="checkedDriverDetails"
          @refreshData="$router.push('/trip-request/backup/requests')"
        ></InvitePartnersToBackupTRVue>
      </div>
    </div>
  </teleport>
</template>

<script>
import moment from 'moment';
import http from '../../config/axios';
import httpUserService from '../../config/axiosUserService';
import addCar from './addCar.vue';
import PartnerCarEdit from './partnerCarEdit.vue';
import PartnerEdit from './partnerEdit.vue';
import PartnerLicenseType from './partnerLicenseType.vue';
import PartnerStatusChange from './partnerStatusChange.vue';
import ReplaceDriver from './replaceDriver.vue';
import InvitePartnersToBackupTRVue from '../../components/partnerLocation/InvitePartnersToBackupTR.vue';

export default {
  name: 'InvitePartnerDatatable',
  components: {
    PartnerStatusChange,
    PartnerLicenseType,
    PartnerCarEdit,
    PartnerEdit,
    addCar,
    ReplaceDriver,
    InvitePartnersToBackupTRVue
  },
  data: function () {
    return {
      baseUrl: process.env.VUE_APP_API_URL.slice(0, -4),
      // baseUrl: 'http://partner.shuttlengine.com/',
      // baseUrl: 'http://13.228.99.37/shuttle-partner/',
      // baseUrl: 'http://127.0.0.1:8000/',
      selected: [],
      inviteId: [],
      opened: [],
      isPartnerChecked: [],
      isLoading: true,
      driverDetails: [],
      paginationValue: '',
      trip_request_id: '',
      permission: '',
      driverInfo: '',
      partnerModalInfo: {
        title: null,
        imageName: null
      },
      selectedPartner: null,
      selectedDriver: null,
      selectedCar: null,
      cityList: [],
      areaList: [],
      carTypeList: [],
      carBrandList: [],
      carModelList: [],
      dummyOwnerCarList: ['dummy_1', 'dummy_2'],
      carInfo: {},
      searchDriverFromPartnerPage: localStorage.getItem(
        'searchDriverFromPartnerPage'
      ),
      checkedDriverDetails: []
    };
  },
  props: { partners: Array, drivers: Array },

  mounted() {
    if (JSON.parse(localStorage.getItem('trip')) != null) {
      this.trip_request_id = JSON.parse(
        localStorage.getItem('trip')
      ).tripRequest.id;
    }

    this.permission = localStorage.getItem('userPermission').split(',');

    this.getCityList();
    this.getAreaList();
    this.getCarTypeList();
    this.getCarBrandList();
    this.getCarModelList();
  },
  updated() {
    if (this.drivers.length != 0) {
      this.isLoading = false;
    }
    //this.getDriverDetails();
  },
  methods: {
    openReplaceDriverModal(carInfo) {
      this.carInfo = carInfo;
      this.$refs.replaceDriverOpenBtn.click();
    },
    checkVisibility(userCode) {
      const index = this.opened.indexOf(userCode);
      if (index > -1) {
        this.opened.splice(index, 1);
      } else {
        this.opened.length = 0;
        this.opened.push(userCode);
      }
    },

    gerDriverInfo(driverInfo) {
      this.driverInfo = '';
      this.driverInfo = driverInfo;
    },

    // setPartnerModalInfo(title, imageName) {
    //   this.partnerModalInfo = {
    //     title: title,
    //     imageName: imageName
    //   };
    // },

    selectPartnerInfo(partner) {
      this.selectedPartner = partner;
      this.selectedDriver = this.drivers.find(
        (driver) => driver.user_code === partner.user_id
      );
    },

    selectCar(carInfo) {
      this.selectedCar = carInfo;
    },

    roleFromUserService(userId) {
      let role = 'N/A';
      let selectedDriver = null;
      this.drivers.forEach((driver) => {
        if (driver.user_code === userId) {
          selectedDriver = driver;
        }
      });
      if (selectedDriver && selectedDriver.role) {
        selectedDriver.role.forEach((driverRole) => {
          if (role !== 'Owner' && driverRole.name === 'Driver') {
            role = 'Driver';
          } else if (driverRole.name === 'Owner') {
            role = 'Owner';
          }
        });
      }
      return role;
    },

    makeOwner(partner) {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to make this driver an Owner!',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, make Owner!'
      }).then((result) => {
        if (result.value) {
          httpUserService
            .post(`/v1/users/attach-linked-user`, {
              user_code: partner.user_id,
              role: 'Driver',
              linked_user_code: partner.user_id,
              linked_user_role: 'Owner',
              system: 'Partner App'
            })
            .then(
              (response) => {
                if (response.status === 200) {
                  http
                    .post('v2/partners/makeOwner', {
                      user_id: partner.user_id
                    })
                    .then((res) => {
                      this.$swal({
                        icon: 'success',
                        title: 'Congratulations!',
                        text: res.data.message
                      });
                      this.$emit('refreshPaginationData');
                    })
                    .catch((error) => {
                      console.log(error);
                      this.$swal('Error', error.response.data.message, 'error');
                    });
                }
              },
              (error) => {
                console.log(error);
                this.$swal('Error', error.response.data.message, 'error');
              }
            );
        }
      });
    },

    getCityList() {
      http
        .get('v2/settings/locations')
        .then((response) => {
          if (response.status == 200) {
            this.cityList = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getAreaList() {
      http
        .get('v2/settings/areas')
        .then((response) => {
          if (response.status == 200) {
            this.areaList = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCarTypeList() {
      http
        .get('v2/settings/car-types')
        .then((response) => {
          if (response.status == 200) {
            this.carTypeList = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCarBrandList() {
      http
        .get('v2/settings/car-brands')
        .then((response) => {
          if (response.status == 200) {
            this.carBrandList = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    getCarModelList() {
      http
        .get('v2/settings/car-models')
        .then((response) => {
          if (response.status == 200) {
            this.carModelList = response.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },

    clearModalData() {
      this.driverInfo = '';
    },

    formatDateUsingMoment(date) {
      return moment(date).format('DD.MM.YYYY');
    },

    checkInviteId() {
      if (this.selected.length === 0) {
        this.$swal(
          'Warning',
          'Please, select at least one partner!',
          'warning'
        );
      } else {
        this.inviteId = this.selected;
        this.sendSmsToPartner();
      }
    },

    selectCheckbox() {
      if (this.partners.length !== this.isPartnerChecked.length) {
        this.isPartnerChecked.length = 0;
        this.selected.length = 0;

        this.$props.partners.forEach((partner) => {
          let partnerMobileNumber = this.$props.drivers.find(
            (driver) => driver.user_code === partner.user_id
          )
            ? this.$props.drivers.find(
                (driver) => driver.user_code === partner.user_id
              ).mobile
            : 0;
          this.isPartnerChecked.push(partner.user_id);
          if (partner.user_id !== null && partnerMobileNumber !== 0) {
            this.selected.push({
              id: partner.user_id,
              mobile: partnerMobileNumber
            });
          }
        });
      } else {
        this.isPartnerChecked.length = 0;
        this.selected.length = 0;
      }
    },

    checkWhichOneCheckout(id, mobileNumber) {
      const ind = this.isPartnerChecked.indexOf(id);
      if (ind > -1) {
        this.isPartnerChecked.splice(ind, 1);
      } else {
        this.isPartnerChecked.push(id);
      }
      let index = this.selected.findIndex((item) => item.id === id);
      if (index > -1) {
        this.selected.splice(index, 1);
      } else {
        this.selected.push({
          id,
          mobile: mobileNumber
        });
      }
    },

    sendSmsToPartner() {
      this.$swal({
        title: 'Are you sure?',
        text: 'You are about to send an SMS!',
        icon: 'warning',
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, send sms!'
      }).then((result) => {
        if (result.value) {
          if (JSON.parse(localStorage.getItem('trip')) === null) {
            this.$swal({
              title: 'Create Trip Request!',
              text: 'Before sending an SMS, please create a trip request!',
              icon: 'warning',
              type: 'warning'
            });
          } else {
            if (this.selected.length !== 20) {
              const dataObject = {
                trip_request_id: JSON.parse(localStorage.getItem('trip'))
                  .tripRequest.id,
                partner_id: this.selected.map((item) => item.id),
                mobile: this.selected.map((item) => item.mobile),
                resend: ''
              };

              http
                .post('v2/partners/triprequests/invitations', dataObject)
                .then((response) => {
                  if (response.status === 200) {
                    this.$swal('Submit!', 'Your sms has been sent.', 'success');
                    this.$router.push({ path: '/trip-request/trip/requests' });
                    localStorage.removeItem('trip');
                  }
                })
                .catch((error) => {
                  console.log(error);
                  this.errored = true;
                });
            } else {
              let counter = 0;
              for (
                let ind = 0;
                ind < Math.round(this.selected.length / 20);
                ind++
              ) {
                counter++;
                let splicePartnerArray = this.selected.splice(ind, 20);

                const dataObject = {
                  trip_request_id: JSON.parse(localStorage.getItem('trip'))
                    .tripRequest.id,
                  partner_id: splicePartnerArray.map((item) => item.id),
                  mobile: splicePartnerArray.map((item) => item.mobile),
                  resend: ''
                };

                http
                  .post('v2/partners/triprequests/invitations', dataObject)
                  .then((response) => {
                    if (
                      response.status === 200 &&
                      counter === Math.round(this.selected.length / 50)
                    ) {
                      this.$swal(
                        'Submit!',
                        'Your sms has been sent.',
                        'success'
                      );
                      this.$router.push({ name: 'trip-request' });
                      localStorage.removeItem('trip');
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    this.errored = true;
                  });
                ind--;
              }
            }
          }
        }
      });
    },
    goTripRequest() {
      this.$router.push('/trip-request/trip/requests');
    },
    // getDriverDetails() {
    //   let partner_id = [];
    //
    //   this.$props.partners.forEach((object) => {
    //     partner_id.push(object.id);
    //     // partner_id = [...new Set(partner_id)];
    //   });
    //
    //   partner_id = [...new Set(partner_id)];
    //
    //   for (let ind = 0; ind < partner_id.length; ind++) {
    //     let codes = partner_id.splice(ind, 50);
    //     userService.get(`v1/users?user_code=${codes.join(',')}&fields=name,mobile,user_code,email`)
    //       .then((response) => {
    //         this.driverDetails = [...this.driverDetails, ...response.data.data];
    //       })
    //       .catch((error) => {
    //         console.log(error);
    //       });
    //     ind--;
    //   }
    // }
    filter(e) {
      //console.log(e.target.value,);
      this.paginationValue = e.target.value;
      this.$emit('sendPaginationCount', this.paginationValue);
    }
  },
  computed: {
    selectAll() {
      if (this.partners.length != this.isPartnerChecked.length) {
        return false;
      }
      return true;
    }
  },
  watch: {
    partners(newValue, oldValue) {
      if (JSON.stringify(newValue) !== JSON.stringify(oldValue)) {
        this.isPartnerChecked = [];
        this.selected = [];
      }
    },
    selected: {
      handler() {
        this.checkedDriverDetails = [];
        this.selected.forEach((driver) => {
          this.checkedDriverDetails.push({
            user_code: driver.id,
            mobile: driver.mobile
          });
        });
      },
      deep: true
    }
  }
};
</script>
<style scoped>
table > thead > tr > th {
  font-size: 12px;
  font-weight: bold;
  background-color: #f3f3f3;
}

table > tbody > tr > td {
  font-weight: 100;
  font-family: 'Montserrat';
  font-size: 11px;
}

table {
  font-family: Montserrat;
  font-size: 12px;
  font-weight: 600;
  line-height: 12px;
  font-style: normal;
}

.table thead > tr > th {
  vertical-align: bottom;
  border-bottom: 2px solid #f8f9fa;
  background: #f3f3f3;
}

#cardHeader {
  padding: 0.5rem 1rem;
  margin-bottom: 0;
  background: none;
  border-bottom: none;
}

#inviteButton {
  background-color: #1c2457;
  border-color: #1c2457;
  height: 47px;
  width: 154px;
  font-size: 18px;
  text-align: center;
  text-decoration: none;
  font-family: Montserrat;
  font-weight: bold;
  margin-right: 11px;
}

.btn.btn-sm.btn-info {
  background: #f3f3f3;
  border: 2px solid #1c2457;
}

.edit-partner-buttons {
  float: right;
}

#partner-table {
  padding: 20px;
}

@media (min-width: 768px) {
  #inviteButton {
    background-color: #1c2457;
    border-color: #1c2457;
    height: 39px;
    width: 84px;
    font-size: 16px;
    text-align: center;
    text-decoration: none;
    font-family: Montserrat;
    font-weight: bold;
    margin-right: 6px;
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  #inviteButton {
    background-color: #1c2457;
    border-color: #1c2457;
    height: 46px;
    width: 116px;
    font-size: 17px;
    text-align: center;
    text-decoration: none;
    font-family: Montserrat;
    font-weight: bold;
    margin-right: 9px;
  }
}

@media (min-width: 1200px) {
  #inviteButton {
    background-color: #1c2457;
    border-color: #1c2457;
    height: 46px;
    width: 153px;
    font-size: 17px;
    text-align: center;
    text-decoration: none;
    font-family: Montserrat;
    font-weight: bold;
    margin-right: 7px;
  }

  #skipButton {
    background-color: white;
    border-color: white;
    height: 46px;
    width: 153px;
    font-size: 17px;
    text-align: center;
    text-decoration: none;
    font-family: Montserrat;
    font-weight: bold;
    color: black;

    /*margin-right: 7px;*/
  }

  .top-table-buttons button {
    float: right;
    margin-left: 15px;
  }
}
</style>
